import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import s from './InputSeacrh.scss';
import Link from '../../../components/Link/Link';
import analyticsWrapper from '../../../helpers/analytics/analyticsWrapper';

const InputSearch = ({
  placeholder,
  searchHandler,
  dropDown,
  cityId,
  ga4Type = '',
  ga4Category = '',
  ga4Label = '',
}) => {
  const dropdownRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const handleChange = e => {
    setIsOpen(true);
    searchHandler(e);
  };

  const handleClickOutside = event => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  const ga4Call = label => {
    analyticsWrapper('ga4', {
      event: 'user_click',
      type: ga4Type,
      category: ga4Category,
      label: `${ga4Label || label}`,
      msid: `${cityId || ''}`,
    });
  };

  return (
    <div className={`${s.searchWrap} inputSearchWrap`} ref={dropdownRef}>
      <i className={s.serachIcon} />
      <input
        type="search"
        placeholder={placeholder}
        onClick={e => {
          e.preventDefault();
          if (ga4Type || ga4Category) {
            ga4Call('no_selection');
          }
        }}
        onChange={handleChange}
      />
      {isOpen &&
        (dropDown && Array.isArray(dropDown) && dropDown.length > 0) && (
          <ul
            className={`${s.sortList} ${
              dropDown && Array.isArray(dropDown) && dropDown.length > 0
                ? s.show
                : ''
            }`}
          >
            {dropDown.map((item, index) => (
              <li key={index}>
                <Link
                  to={item.link}
                  ga4Data={
                    (ga4Category || ga4Type) && [
                      {
                        event: 'user_click',
                        type:
                          ga4Label === 'weather_aqi_landing'
                            ? `${item?.name}_click`
                            : ga4Type,
                        category: ga4Category,
                        label: `${ga4Label || item?.name.toLowerCase()}`,
                        msid: `${cityId}`,
                      },
                    ]
                  }
                >
                  {item.name}
                </Link>
              </li>
            ))}
          </ul>
        )}
    </div>
  );
};

InputSearch.propTypes = {
  searchHandler: PropTypes.func.isRequired,
  placeholder: PropTypes.string.isRequired,
};

export default InputSearch;
